import isEmpty from '../../utility/isEmpty'
import { defaultObj } from './state'

export default {
  setLoans (state, loans) {
    if (loans) {
      state.loans = loans
    }
  },

  updateLoan (state, loan) {
    state.loans = state.loans.map((loanFromState) => {
      if (loanFromState.loanId === loan.loanId) {
        return loan
      } else {
        return loanFromState
      }
    })
  },

  updateApplications (state, applicationStatus) {
    if (applicationStatus && applicationStatus.appStatus) {
      if (applicationStatus.appStatus.TLXe) {
        state.currentTlxeApplicationInProgress = applicationStatus.appStatus.TLXe.applicationInProgress
        state.expressApplicationDeepLink = applicationStatus.appStatus.TLXe.returnUrl
        state.declinedTlxeApplications = isEmpty(applicationStatus.appStatus.TLXe.declinedResults) ? [] : applicationStatus.appStatus.TLXe.declinedResults.map(app => app.applicationLoanInfo)
      }

      if (applicationStatus.appStatus.NLS) {
        const result = applicationStatus.appStatus.NLS.statusResult || {}
        state.currentNlsApplication = result
        state.nlsUploadDocEnabled = !isEmpty(result.applicationLoanInfo) ? result.applicationLoanInfo.canUploadLoanDocuments || false : false
        state.declinedNlsApplications = isEmpty(applicationStatus.appStatus.NLS.declinedResults) ? [] : applicationStatus.appStatus.NLS.declinedResults.map(app => app.applicationLoanInfo)
      }
    } else {
      state.currentNlsApplication = {}
      state.declinedNlsApplications = []
      state.declinedTlxeApplications = []
    }
  },

  setDashboardReapplyInfo (state, loanReapplyInfo) {
    if (loanReapplyInfo) {
      state.dashboardReapplyInfo = loanReapplyInfo
    }
  },

  setCreditLimitModal (state, value) {
    state.showCreditLimitModal = value
  },

  setSettlementStatus (state, status) {
    state.settlementStatus = {
      loanId: status.loanId,
      docExp: status.docExp,
      docSigned: status.docSigned,
      paymentMade: status.paymentMade
    }
  },

  setRateChangeModal (state, data) {
    state.showRateChangeModal = data
  },

  setRefinanceDenial (state, data) {
    state.refinanceDenied = data
  },

  resetLoans (state) {
    state.loans = []
  },

  reset (state) {
    if (this.cache.has('loans/getLoans') === true) {
      this.cache.delete('loans/getLoans')
    }

    state = Object.assign(state, defaultObj)
  }
}
